<div class="checklist-box">
    <h4 class="block-title block-title-16 px-4" (click)="$event.stopPropagation()">
      Import Template
    </h4>
    <div class="height-custom-cls">
      <mat-accordion (click)="$event.stopPropagation()">
        <mat-expansion-panel
          class="checklist-expansion-panel"
          *ngFor="let a of customTemplate"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-checkbox
                  class="p-0 custom-checkbox me-3"
                  [(ngModel)]="a.checked"
                  (change)="checkSelected($event, a)">
                </mat-checkbox>
              <!-- <input
                type="checkbox"
                [(ngModel)]="a.checked"
                class="p-0 custom-checkbox__only-border me-3"
                (change)="checkSelected($event, a)"
              /> -->
              <div class="d-flex align-items-center checklist-user">
                <!-- <img *ngIf="a.image" src="{{ a.image }}" alt="" /> -->
                <label
                  *ngIf="!a.image"
                  style="cursor: pointer !important"
                  class="short-name mr-1"
                  placement="auto"
                  >{{ utils.forShortName(a.template_name) }}</label
                >
                <div class="m-1 checklist-title-wrap">
                  <h4>{{ a.template_name }}</h4>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="checklist-lists">
            <li *ngFor="let labelValue of a.tasks">
              {{ labelValue?.subtask_name }}
            </li>
          </ul>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <button
      [ngClass]="!templatelistData?.length ? 'disable-cls' : ''"
      class="btn-cus-cls anchor-link my-3 float-end me-4"
      (click)="checkedChecklist()"
      [disabled]="templatelistData?.length == 0"
    >
      Submit
    </button>
  </div>



